import React from 'react';
import paginationLast from '../assets/images/pagination-last.svg';

export default () => {
  return <img src={paginationLast} alt="Last Page" />;
};
